export default "__VITE_ASSET__BehEAr28__"